/* NBN live incident mitigation 2026-08-12T12:10:45.796Z: stale cart helper disabled after rollback. */
(function(){ window.__nbnStaleCartHelperDisabled = true; })();
